import { tipoDoAnexo } from './attachmentKind';

// O que vira o texto de uma mensagem que carrega um anexo.
//
// Uma mensagem de voz não tem texto: o "Arquivo anexado: audio-2026-09-17
// T00-24-57.webm" aparecia como uma etiqueta em cima do player, anunciando o
// instante da gravação — que não diz nada a quem lê. Para os outros anexos o
// nome continua sendo a única pista do que chegou antes de abrir o arquivo.
export function textoDaMensagemDeAnexo(
  fileName: string,
  fileType: string,
  caption?: string
): string {
  const legenda = caption?.trim();
  if (legenda) return legenda;

  if (tipoDoAnexo(fileType) === 'audio') return '';

  return `Arquivo anexado: ${fileName}`;
}

// A lista de conversas mostra o texto da última mensagem. Sem texto, a linha
// ficaria em branco justamente na conversa que acabou de receber algo.
export const PREVIA_DE_MENSAGEM_DE_VOZ = '🎤 Mensagem de voz';
